import React from 'react';
import PropTypes from 'prop-types';
import { 
  TextField,
  useTheme
} from '@mui/material';
import { tokens } from 'theme/tokens';

const InputField = props => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { label,
    name,
    type,
    value,
    variant='outlined',
    size='small',
    fullWidth=true,
    disabled=false,
    hidden=false,
    margin='none',
    error,
    helperText,
    onBlur,
    onChange,
    className,
    multiline,
    minRows,
    sx,
    slotProps,
  } = props;
  return (
    <TextField
      label={label}
      name={name}
      type={type}
      value={value}
      variant={variant}
      fullWidth={fullWidth}
      error={error}
      disabled={disabled}
      hidden={hidden}
      autoComplete='off'
      size={size}
      margin= {margin || 'none'}
      multiline={multiline}
      minRows={minRows}
      helperText={helperText}
      onBlur={onBlur}
      onChange={onChange}
      className={className}
      color={colors.neutral[50]}
      sx={sx}      
      slotProps={slotProps}
    />
  );
};

InputField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.oneOf(['text', 'number', 'password', 'date', 'tel', 'email']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),  
  onChange: PropTypes.func,
};

export default InputField;